import {
  STORE_STATE,
  STORE_STATE_RESET,
} from './types';

export function storeState({
  current,
  ownershipType,
  projectType,
  projectName,
  projectDetails,
  loanAmount,
  validateLoanAmount,
  selectedBank,
  agreement,
}) {
  return {
    type: STORE_STATE,
    payload: {
      current,
      ownershipType,
      projectType,
      projectName,
      projectDetails,
      loanAmount,
      validateLoanAmount,
      selectedBank,
      agreement,
    },
  };
}

export function resetStore() {
  return {
    type: STORE_STATE_RESET,
  };
}



// WEBPACK FOOTER //
// ./src/redux/storage/actions.js